import React from "react";
import Banner from "@/components/pages/home/banner";
import About from "@/components/pages/home/about";
import ProductGrid from "@/components/pages/product.js/product-grid";
import SectionHeading from "@/components/ui/carousel/section-heading";
import Section from "@/components/ui/section";
import Seo from "@/utils/seo";
import { homeDecor } from "@/data/homeDecor";
import { lifestyle } from "@/data/lifestyle";
export default function Home() {
  return (
    <>
      <Seo />
      <Banner />
      <About />
      <Section className="bg-beige" variant="flat">
        <SectionHeading title="Serve-in-Style" tag="home" />
        <ProductGrid products={lifestyle} />
      </Section>
      <Section className="bg-darkBeige" variant="flat">
        <SectionHeading title="Home Decor" tag="lifestyle" />
        <ProductGrid products={homeDecor} />
      </Section>
    </>
  );
}
